import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectIndexEventsWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.INDEX_EVENTS];

export const selectIndexEventsState = (state: State, widgetKey: string) =>
    selectIndexEventsWidgetsState(state)[widgetKey];
